module.exports = __webpack_public_path__ + "static/media/background-video.42b7f010.mp4";